var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5V11.5C8 11.1464 8.14048 10.8072 8.39052 10.5572C8.64057 10.3071 8.97971 10.1667 9.33333 10.1667H15C15.3536 10.1667 15.6928 10.3071 15.9428 10.5572C16.1929 10.8072 16.3333 11.1464 16.3333 11.5V16.5C16.3333 16.8536 16.1929 17.1927 15.9428 17.4428C15.6928 17.6928 15.3536 17.8333 15 17.8333H9.33333C8.97971 17.8333 8.64057 17.6928 8.39052 17.4428C8.14048 17.1927 8 16.8536 8 16.5ZM19.4453 10.6607L16.7787 13.036C16.7435 13.0672 16.7154 13.1055 16.6961 13.1483C16.6768 13.1912 16.6667 13.2377 16.6667 13.2847V14.47C16.6667 14.517 16.6768 14.5634 16.6961 14.6063C16.7154 14.6492 16.7435 14.6874 16.7787 14.7187L19.4453 17.094C19.4934 17.1367 19.5527 17.1645 19.6162 17.1742C19.6798 17.184 19.7447 17.1751 19.8033 17.1488C19.8619 17.1224 19.9117 17.0797 19.9466 17.0258C19.9815 16.9718 20 16.9089 20 16.8447V10.91C20 10.8457 19.9815 10.7828 19.9466 10.7289C19.9117 10.6749 19.8619 10.6322 19.8033 10.6059C19.7447 10.5795 19.6798 10.5707 19.6162 10.5804C19.5527 10.5901 19.4934 10.618 19.4453 10.6607Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInterview);
export default __webpack_public_path__ + "static/media/icon-interview.c23b33b7b72559a38f61a366228e757d.svg";
export { ForwardRef as ReactComponent };